import { formatPercentage } from "@utils/formatPercentage";

/** `part` as a percentage of `whole`; "-" when `whole` is 0, never "∞%". */
export const percentOf = (part: number, whole: number) =>
  whole ? formatPercentage(part / whole) : "-";
